import React, { useState, useEffect } from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  hourUnit: { id: 'hourUnit', defaultMessage: 'h' },
  minuteUnit: { id: 'minuteUnit', defaultMessage: 'min' },
  secondUnit: { id: 'secondUnit', defaultMessage: 's' },
});

const AudioDurationDisplay = ({ audioRef }) => {
  const intl = useIntl();
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const updateDuration = () => {
      if (!isNaN(audio.duration)) {
        setDuration(audio.duration);
      }
    };

    audio.addEventListener('loadedmetadata', updateDuration);

    return () => {
      audio.removeEventListener('loadedmetadata', updateDuration);
    };
  }, [audioRef]);

  // Muodostetaan ajan näyttö muodossa h:mm:ss
  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    if (hours > 0) {
      return (
        `${hours} ${intl.formatMessage(messages.hourUnit)} ` +
        `${minutes} ${intl.formatMessage(messages.minuteUnit)} ` +
        `${seconds} ${intl.formatMessage(messages.secondUnit)}`
      );
    } else if (minutes > 0) {
      return (
        `${minutes} ${intl.formatMessage(messages.minuteUnit)} ` +
        `${seconds} ${intl.formatMessage(messages.secondUnit)}`
      );
    } else {
      return `${seconds} ${intl.formatMessage(messages.secondUnit)}`;
    }
  };

  return <span className="AudioDuration">{formatTime(duration)}</span>;
};

export default AudioDurationDisplay;
